import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import { createSelector } from "reselect";
import {
  setSelectedToFalseExceptPackage,
  setSelectedToFalseExceptSelected,
} from "./helperfuncs";

const slice = createSlice({
  name: "verticals",
  initialState: {
    list: [],
    verticalsSelected: [],
  },
  reducers: {
    verticalsReceived: (verticals, action) => {
      verticals.list = setSelectedToFalseExceptPackage(action.payload);
    },
    VerticalAdded: (verticals, action) => {
      verticals.verticalsSelected.push(action.payload);
    },
    VerticalRemoved: (verticals, action) => {
      verticals.verticalsSelected = verticals.verticalsSelected.filter(
        (item) => item !== action.payload
      );
    },

    changeSelectedVertical: (verticals, action) => {
      verticals.list = setSelectedToFalseExceptSelected(
        verticals.list,
        action.payload
      );
    },
  },
});

export const {
  verticalsReceived,
  VerticalAdded,
  VerticalRemoved,
  changeSelectedVertical,
} = slice.actions;

export default slice.reducer;

// action creator
export const loadverticals = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/verticals",
    method: "get",
    data: data,
    onSuccess: verticalsReceived.type,
  });

// Selector

export const getVerticalList = createSelector(
  (state) => state.entities.verticals,
  (verticals) => verticals.list
);

export const getVerticalsSelected = createSelector(
  (state) => state.entities.verticals,
  (verticals) => verticals.verticalsSelected
);
